import type { IWalletImgIconProps } from './helpers';

export const WalletIcon = ({ variant = 'default', ...props }: IWalletImgIconProps) => {
	if (variant === 'wallet-2')
		return (
			<svg
				width='12'
				height='12'
				viewBox='0 0 12 12'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					d='M7.5 3.07581L3 3.07581C1.895 3.07581 1 3.97081 1 5.07581L1 3.27078C1 2.25078 1.825 1.42578 2.845 1.42578L5.655 1.42578C6.675 1.42578 7.5 2.05581 7.5 3.07581Z'
					fill='#05A2BF'
				/>
				<path
					opacity='0.4'
					d='M8.73999 6.09921C8.48999 6.34421 8.37 6.7142 8.47 7.0892C8.595 7.5542 9.05501 7.84921 9.535 7.84921H10V8.57422C10 9.67922 9.105 10.5742 8 10.5742H3C1.895 10.5742 1 9.67922 1 8.57422L1 5.07422C1 3.96922 1.895 3.07422 3 3.07422L8 3.07422C9.1 3.07422 10 3.97422 10 5.07422V5.79919H9.45999C9.17999 5.79919 8.92499 5.90921 8.73999 6.09921Z'
					fill='#05A2BF'
				/>
				<path
					d='M11.0001 6.31079V7.34079C11.0001 7.62079 10.7701 7.8508 10.4851 7.8508H9.5201C8.9801 7.8508 8.48511 7.4558 8.44011 6.9158C8.41011 6.6008 8.5301 6.3058 8.7401 6.1008C8.9251 5.9108 9.1801 5.80078 9.4601 5.80078H10.4851C10.7701 5.80078 11.0001 6.03079 11.0001 6.31079Z'
					fill='#05A2BF'
				/>
				<path
					d='M6.5 5.94922L3.5 5.94922C3.295 5.94922 3.125 5.77922 3.125 5.57422C3.125 5.36922 3.295 5.19922 3.5 5.19922L6.5 5.19922C6.705 5.19922 6.875 5.36922 6.875 5.57422C6.875 5.77922 6.705 5.94922 6.5 5.94922Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	if (variant === 'crypto-settings')
		return (
			<svg
				width='80'
				height='80'
				viewBox='0 0 80 80'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					d='M70 25C54.9178 25.0002 28.8878 24.9998 13.75 25C12.1255 24.974 12.094 22.5326 13.7501 22.5H22.9625C24.299 20.8399 27.7086 16.6043 29 15H15C8.8 15 3.75 20.05 3.75 26.25V61.25C3.75 67.45 8.8 72.5 15 72.5H70C73.45 72.5 76.25 69.7 76.25 66.25V58.75C77.5009 58.7601 47.6049 58.7427 47.5 58.75C45.4375 58.75 43.75 57.0624 43.75 55V42.5C43.75 40.4375 45.4375 38.75 47.5 38.75C48.3604 38.7424 76.384 38.7555 76.25 38.75V31.25C76.25 27.8 73.45 25 70 25Z'
					fill='#05A2BF'
				/>
				<path
					d='M53.8248 22.5C52.4717 20.8181 49.0906 16.6196 47.7873 15L42.8623 8.8875C42.1498 8 41.0998 7.5 39.9998 7.5C38.8998 7.5 37.8498 8 37.1373 8.8875L32.2123 15C30.9086 16.597 27.5148 20.8516 26.1748 22.5H53.8248Z'
					fill='#82D0DF'
				/>
				<path
					d='M55.0001 46.25C51.7158 46.3131 51.7163 51.1873 55.0002 51.25C58.2843 51.1867 58.2838 46.3126 55.0001 46.25Z'
					fill='#05A2BF'
				/>
				<path
					d='M47.5 41.25C46.8125 41.25 46.25 41.8125 46.25 42.5V55C46.25 55.6875 46.8125 56.25 47.5 56.25C48.3941 56.2525 76.3361 56.2483 76.25 56.25V41.25C76.2349 41.25 48.4819 41.25 47.5 41.25ZM55 53.75C48.4052 53.5843 48.4065 43.9148 55.0001 43.75C61.5947 43.9158 61.5935 53.5851 55 53.75Z'
					fill='#82D0DF'
				/>
				<path
					d='M57.0375 22.5H67.5C67.9363 18.5981 65.3226 15.0095 61.2499 15H51C52.2764 16.5855 55.7174 20.8601 57.0375 22.5Z'
					fill='#05A2BF'
				/>
			</svg>
		);

	return (
		<svg
			width='60'
			height='61'
			viewBox='0 0 60 61'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<rect
				y='0.192383'
				width='60'
				height='60'
				rx='30'
				fill='#05A2BF'
			/>
			<path
				opacity='0.4'
				d='M42.9168 30.1917L42.9168 36.6501C42.9168 40.5251 40.3335 43.1084 36.4585 43.1084L23.5418 43.1084C19.6668 43.1084 17.0835 40.5251 17.0835 36.6501L17.0835 30.1917C17.0835 26.6784 19.2018 24.2242 22.4956 23.8109C22.8314 23.7592 23.1802 23.7334 23.5418 23.7334L36.4585 23.7334C36.7943 23.7334 37.1172 23.7463 37.4272 23.798C40.7597 24.1855 42.9168 26.6526 42.9168 30.1917Z'
				fill='white'
			/>
			<path
				d='M37.4278 23.7993C37.1178 23.7476 36.7948 23.7347 36.459 23.7347L23.5423 23.7347C23.1807 23.7347 22.8319 23.7605 22.4961 23.8122C22.6769 23.4505 22.9353 23.1147 23.2453 22.8047L27.4432 18.5939C29.2128 16.8372 32.0803 16.8372 33.8498 18.5939L36.1103 20.8801C36.9369 21.6939 37.3761 22.7272 37.4278 23.7993Z'
				fill='white'
			/>
			<path
				d='M42.9168 30.8389L39.0418 30.8389C37.621 30.8389 36.4585 32.0014 36.4585 33.4222C36.4585 34.843 37.621 36.0055 39.0418 36.0055L42.9168 36.0055'
				fill='white'
			/>
		</svg>
	);
};
